import {
  type ComponentPropsWithoutRef,
  type ComponentPropsWithRef,
  type FC,
} from 'react';
import { cn } from 'src/utils/cn';

// "3fr minmax(0, 7fr)" prevents form fields from overflowing.
// "30% 70%" does not work exactly the same as the form fields could bleed into the padding of a parent component.
export const fieldLayoutGridTemplateColumnsClass = cn(
  'grid-cols-[3fr_minmax(0,7fr)]'
);

type FieldLayoutProps = {
  stacked?: boolean;
  inline?: boolean;
} & ComponentPropsWithoutRef<'div'>;

export const FieldLayout: FC<FieldLayoutProps> = ({
  stacked,
  inline,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(
        'gap-xs',
        inline ? 'inline-grid' : 'grid',
        stacked && 'grid-flow-row',
        // in firefox "align-items: baseline;" did not work well for our current
        // textarea component, so we need to use "align-items: flex-start;" for every
        // field. this is not super accurate, but okay.
        !stacked &&
          `
            grid-flow-col items-baseline
            firefox:items-start
          `,
        !stacked && fieldLayoutGridTemplateColumnsClass,
        props.className
      )}
    />
  );
};

export const FieldItem: FC<ComponentPropsWithRef<'div'>> = (props) => {
  return <div {...props} className={cn('items-baseline', props.className)} />;
};
